import React from "react";
import { Box, Typography, Chip, Paper, useTheme } from "@mui/material";
import {
  type TemplateEntry,
  type ServiceSpec,
} from "../../../data/template-registry";
import { SERVICE_TYPE_COLORS, headerStyle, cellStyle } from "./template-utils";

interface TemplateServicesTableProps {
  template: TemplateEntry;
}

export const TemplateServicesTable: React.FC<TemplateServicesTableProps> = ({
  template,
}) => {
  const theme = useTheme();
  const { services } = template;

  return (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h2" component="h2" gutterBottom fontWeight={600}>
        Infrastructure Specs
      </Typography>
      <Paper sx={{ overflow: "hidden" }}>
        <Box sx={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: theme.palette.grey[100] }}>
                <th style={headerStyle}>Service</th>
                <th style={headerStyle}>Type</th>
                <th style={headerStyle}>Image</th>
                <th style={headerStyle}>Port</th>
                <th style={headerStyle}>CPU</th>
                <th style={headerStyle}>Memory</th>
                <th style={headerStyle}>Storage</th>
                <th style={headerStyle}>Exposure</th>
              </tr>
            </thead>
            <tbody>
              {services.map((service: ServiceSpec, index: number) => (
                <tr
                  key={service.name}
                  style={{
                    backgroundColor:
                      index % 2 === 0 ? "transparent" : theme.palette.grey[50],
                  }}
                >
                  <td style={cellStyle}>{service.name}</td>
                  <td style={cellStyle}>
                    <Chip
                      label={service.type}
                      size="small"
                      variant="outlined"
                      color={SERVICE_TYPE_COLORS[service.type] || "default"}
                    />
                  </td>
                  <td style={cellStyle}>
                    <Typography variant="caption" fontFamily="monospace">
                      {service.image || service.vcs?.baseImage || "-"}
                    </Typography>
                  </td>
                  <td style={cellStyle}>{service.port || "-"}</td>
                  <td style={cellStyle}>{service.resources.cpu}</td>
                  <td style={cellStyle}>{service.resources.memory}</td>
                  <td style={cellStyle}>{service.storage || "-"}</td>
                  <td style={cellStyle}>
                    <Chip
                      label={service.internetFacing ? "Public" : "Private"}
                      size="small"
                      color={service.internetFacing ? "primary" : "default"}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Paper>
    </Box>
  );
};
